/* Coffee Roast Blend country tabs. */
(function () {
  'use strict';

  var SECTION = '[data-coffee-roast-blend]';

  function selectProfile(root, index) {
    root.querySelectorAll('[data-crb-tab]').forEach(function (tab) {
      var selected = tab.dataset.crbTab === index;
      tab.setAttribute('aria-selected', selected ? 'true' : 'false');
      tab.tabIndex = selected ? 0 : -1;
    });

    root.querySelectorAll('[data-crb-details]').forEach(function (panel) {
      panel.hidden = panel.dataset.crbDetails !== index;
    });

    root.querySelectorAll('[data-crb-media]').forEach(function (panel) {
      var selected = panel.dataset.crbMedia === index;
      panel.hidden = !selected;
      panel.setAttribute('aria-hidden', selected ? 'false' : 'true');
    });
  }

  function initRoot(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll('[data-crb-tab]'));
    if (!tabs.length) return;

    tabs.forEach(function (tab, tabIndex) {
      if (tab.dataset.crbBound === 'true') return;
      tab.dataset.crbBound = 'true';

      tab.addEventListener('click', function () {
        selectProfile(root, tab.dataset.crbTab);
      });

      tab.addEventListener('keydown', function (event) {
        var nextIndex = tabIndex;

        if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
          nextIndex = (tabIndex + 1) % tabs.length;
        } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
          nextIndex = (tabIndex - 1 + tabs.length) % tabs.length;
        } else if (event.key === 'Home') {
          nextIndex = 0;
        } else if (event.key === 'End') {
          nextIndex = tabs.length - 1;
        } else {
          return;
        }

        event.preventDefault();
        selectProfile(root, tabs[nextIndex].dataset.crbTab);
        tabs[nextIndex].focus();
      });
    });
  }

  function init(scope) {
    (scope || document).querySelectorAll(SECTION).forEach(initRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });

  document.addEventListener('shopify:section:select', function (event) {
    init(event.target);
  });
})();
